;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Router = APP.module('Router');

	Router.Account = Marionette.AppRouter.extend({
		permissions: {
			'account':          1,
			'notifications':    1,
			'socialConnection': 1,
			'changePassword':   1,
			'coachesBox':       3
		},
		appRoutes: {
			'account': 'account',
			'account/notifications': 'notifications',
			'account/social_connections': 'socialConnection',
			'account/change_password': 'changePassword',
			'account/coaches_box': 'coachesBox'
		}
	});

}(window, APP, Backbone, Marionette, $, _));